'use client';

import type { Session } from 'next-auth';
import { type PropsWithChildren } from 'react';
import { useSession } from 'next-auth/react';
import { setApiAuthSession } from '@/libs/axios/api';

type AuthSessionGateProps = PropsWithChildren & {
  initialSession: Session | null;
};

export const AuthSessionGate = ({
  children,
  initialSession,
}: AuthSessionGateProps) => {
  const { data: session } = useSession();

  setApiAuthSession(session || initialSession || null);

  return children;
};
